import EditIcon from '@mui/icons-material/Edit';
import { Grid, IconButton } from '@mui/material';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { WsSelect, WsSelectObj } from '../../components/WsSelect';
import WsColors from '../../WsColors';

import { GridItem } from './RenderTextInput';
const RenderSelectInput = ({
  name,
  label,
  options,
  defaultValue = '',
  onEditClick,
}: {
  name: string;
  label: string;
  options: WsSelectObj[];
  defaultValue: string;
  onEditClick?: () => void;
}) => {
  const {
    formState: { errors },
  } = useFormContext();
  return (
    <GridItem>
      <Grid container alignItems="center" columnSpacing={2}>
        <Grid item xs={8.5}>
          <WsSelect name={name} label={label} selectArray={options} defaultValue={defaultValue} />
        </Grid>
        {onEditClick && (
          <Grid item xs={3.5} mt={errors?.[name]?.message ? 1 : 4.6}>
            <IconButton
              onClick={onEditClick}
              sx={{
                border: `1px solid ${WsColors.TertiaryShades300}`,
                borderRadius: 1,
                height: 45.75,
              }}
            >
              <EditIcon sx={{ fontSize: 24 }} />
            </IconButton>
          </Grid>
        )}
      </Grid>
    </GridItem>
  );
};

export default RenderSelectInput;
